import { Injectable } from "@angular/core"
import { environment } from "../../environments/environment"
import { Loader } from "@googlemaps/js-api-loader"

@Injectable({
  providedIn: "root",
})
export class GoogleMapsLoaderService {
  private loader: Loader | undefined
  private apiLoaded = false

  async load(): Promise<void> {
    if (this.apiLoaded) {
      return
    }

    this.loader = new Loader({
      apiKey: environment.firebaseConfig.apiKey,
      version: "weekly",
    })

    // Use importLibrary to load the necessary library
    await Promise.all([
      this.loader.importLibrary("maps"),
      this.loader.importLibrary("marker"),
    ])
    this.apiLoaded = true
  }

}
